import axios from 'axios';
import constants from '../constants';
import type { MCWAppInit } from '~/hooks/useLogin/types';

/**
 * Sets the global axios base url and headers
 */
export const initAxios = (mcwAppInit: MCWAppInit) => {
    if (!mcwAppInit) {
        throw new Error('missing app init');
    }
    axios.defaults.baseURL = mcwAppInit.data.apiUrl;
    axios.defaults.headers.common = Object.assign(
        axios.defaults.headers.common,
        {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${mcwAppInit.requestHeaders.authorization}`,
            'X-OAuth-IDToken': mcwAppInit.requestHeaders['x-oauth-idtoken'],
            [constants.requestHeaders.WISE_CLIENT_ID]:
                mcwAppInit.requestHeaders[
                    constants.requestHeaders.WISE_CLIENT_ID
                ]
        }
    );
};

const updateAxiosWiseClientHeader = (mainClientId: string) => {
    axios.defaults.headers[constants.requestHeaders.WISE_CLIENT_ID] =
        mainClientId;
};

const updateAxiosWiseClientIdsHeader = (selectedClientIds: string[]) => {
    axios.defaults.headers[constants.requestHeaders.WISE_CLIENT_IDS] =
        JSON.stringify(selectedClientIds);
};

const getAppConfig = () => {
    const mcwAppInit =
        localStorage.getItem(constants.localStorageKeys.MCW_APP_INIT) || '';
    if (!mcwAppInit) {
        return;
    }
    return JSON.parse(mcwAppInit);
};

const updateWiseClientIdInAppConfig = (mainClientId: string) => {
    const mcwAppConfig = getAppConfig();
    if (!mcwAppConfig) {
        return;
    }
    mcwAppConfig.requestHeaders[constants.requestHeaders.WISE_CLIENT_ID] =
        mainClientId;
    localStorage.setItem(
        constants.localStorageKeys.MCW_APP_INIT,
        JSON.stringify(mcwAppConfig)
    );
};

const updateWiseClientIdsInAppConfig = (selectedClientIds: string[]) => {
    const mcwAppConfig = getAppConfig();
    if (!mcwAppConfig) {
        return;
    }
    mcwAppConfig.requestHeaders[constants.requestHeaders.WISE_CLIENT_IDS] =
        selectedClientIds;
    localStorage.setItem(
        constants.localStorageKeys.MCW_APP_INIT,
        JSON.stringify(mcwAppConfig)
    );
};

// TO BE DEPRECATED AND REPLACED WITH `WISE_CLIENT_IDS` header
export const updateWiseClientIdHeader = (mainClientId: string) => {
    updateAxiosWiseClientHeader(mainClientId);
    updateWiseClientIdInAppConfig(mainClientId);
};

export const updateWiseClientIdsHeader = (selectedClientIds: string[]) => {
    updateAxiosWiseClientIdsHeader(selectedClientIds);
    updateWiseClientIdsInAppConfig(selectedClientIds);
};

export const getUserDetails = () => {
    const mcwAppConfig = getAppConfig();
    return mcwAppConfig?.data?.userDetails;
};

export const getUserAccessToClients = () => {
    return getUserDetails()?.access;
};
